const KEY = "parlor_exit_variation";

export function markParlorExitVariation(variation: string) {
  if (variation !== "A" && variation !== "B") return;
  try {
    sessionStorage.setItem(KEY, variation);
  } catch {
    // 저장할 수 없으면 로그인에서는 기존 창을 사용한다.
  }
}

export function isParlorExitLoginB(query: {
  event_from?: string | string[];
  redirectTo?: string | string[];
}): boolean {
  const fromParlor =
    query.event_from === "uv_parlor_mtch_rqst" ||
    (typeof query.redirectTo === "string" &&
      query.redirectTo.startsWith("/match/parlor-requests/"));
  if (!fromParlor) return false;
  try {
    return sessionStorage.getItem(KEY) === "B";
  } catch {
    return false;
  }
}
